/* ═══════════════════════════════════════════════════════════════════════
   dm-pdp.js — BR-001 상세 본문 v20 움직임                     2026-09-30
   ═══════════════════════════════════════════════════════════════════════
   조각마다 <script defer> 로 불리지만 한 번만 돈다(__dmPdp).
   하는 일 — 전부 「보여주기」만. 측정은 dm-track 이 data-dm 이름표로 한다.
     · 화면에 들어온 조각에 .is-in  (히어로 페이드 · 267g · 증명 막대)
     · 후기 캐러셀 · 스와이프 줄 번호 · 증명 탭 자동 넘김 · 색상 자동 전환
     · 사이즈 가이드 슬라이더 · 상단 탭 현재 위치 · 지구본(화면 밖에선 정지)
   자동 넘김은 손님이 만지면 잠시 멈추고, 화면 밖이면 돌지 않는다.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__dmPdp) return;
  /* 10/8 영어판: 화면 언어가 한국어가 아니면 영어 문구 (구매 칸·쿠폰·하단 바) */
  var EN = (document.documentElement.lang || 'ko').toLowerCase().indexOf('ko') !== 0;
  function L(ko, en) { return EN ? en : ko; }
  window.__dmPdp = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isPC = function () { return window.innerWidth >= 900; };

  /* 화면 안에 있을 때만 도는 타이머 */
  function ticker(el, ms, fn) {
    var t = null, vis = false, hold = 0;
    function run() { stop(); if (vis && !reduce) t = setInterval(function () { if (Date.now() > hold) fn(); }, ms); }
    function stop() { if (t) clearInterval(t); t = null; }
    new IntersectionObserver(function (es) { vis = es[0].isIntersecting; vis ? run() : stop(); }, { threshold: 0.2 }).observe(el);
    return { hold: function (sec) { hold = Date.now() + sec * 1000; } };
  }

  /* 기능마다 따로 「했음」 표시 — 한 조각에 기능이 둘이어도 둘 다 돈다 */
  function once(el, key) { el.__dmp = el.__dmp || {}; if (el.__dmp[key]) return false; el.__dmp[key] = 1; return true; }

  function init(root) {
    root = root || document;

    /* ① 등장 — .is-in */
    root.querySelectorAll('[data-dmp-in]').forEach(function (el) {
      if (!once(el, 'data-dmp-in')) return;
      var th = parseFloat(el.getAttribute('data-dmp-in')) || 0.3;
      if (reduce) { el.classList.add('is-in'); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= th) el.classList.add('is-in'); });
      }, { threshold: [0, th] }).observe(el);
    });

    /* ② 스와이프 줄 번호·막대 (룩북 · 3 POINT) */
    root.querySelectorAll('[data-dmp-rail]').forEach(function (rail) {
      if (!once(rail, 'data-dmp-rail')) return;
      var box = rail.closest('[data-dmp-railbox]') || rail.parentNode;
      var n = rail.children.length, idx = box.querySelector('[data-dmp-idx]'), bar = box.querySelector('[data-dmp-bar]');
      var caps = box.querySelectorAll('[data-cap]');
      function upd() {
        var w = rail.children[0] ? rail.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 10) : rail.clientWidth;
        var i = Math.max(0, Math.min(n - 1, Math.round(rail.scrollLeft / w)));
        if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) i = n - 1;
        if (idx) idx.textContent = String(i + 1).padStart(2, '0');
        if (bar) bar.style.setProperty('--p', ((i + 1) / n * 100) + '%');
        caps.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      }
      rail.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      upd();
    });

    /* ③ 후기 캐러셀 */
    root.querySelectorAll('[data-dmp-voices]').forEach(function (sec) {
      if (!once(sec, 'data-dmp-voices')) return;
      var stage = sec.querySelector('.dmp-voices__stage');
      var cards = Array.prototype.slice.call(stage.children), N = cards.length, cur = 0;
      var idx = sec.querySelector('[data-dmp-vidx]');
      if (!N) return;
      function draw() {
        var pc = isPC();
        cards.forEach(function (c, i) {
          var o = ((i - cur) % N + N) % N; if (o > N / 2) o -= N;
          var a = Math.abs(o), act = pc ? a <= 1 : a === 0;
          c.style.transform = pc ? 'translateX(' + (o * 364) + 'px) scale(' + (act ? 1 : .92) + ')' : 'translateX(' + (o * 80) + '%) scale(' + (a === 0 ? 1 : .86) + ')';
          c.style.opacity = pc ? (a <= 1 ? 1 : a === 2 ? .45 : 0) : (a === 0 ? 1 : a === 1 ? .55 : 0);
          c.style.top = act ? (pc ? '10px' : '8px') : '22px';
          c.style.zIndex = 10 - a;
          c.style.background = pc && !act ? '#EFE8DE' : '';
          c.style.boxShadow = act ? '0 14px 30px rgba(43,38,32,.1)' : (pc ? 'none' : '0 1px 2px rgba(43,38,32,.05)');
          c.style.pointerEvents = a <= 2 ? 'auto' : 'none';
          c.onclick = function () { if (o) go(cur + Math.sign(o)); };
        });
        /* 폰: 긴 후기가 잘리지 않게 칸 높이를 지금 보이는 카드에 맞춤 (PC 는 CSS 고정 380) */
        stage.style.height = pc ? '' : Math.max(300, cards[cur].offsetHeight + 50) + 'px';
        if (idx) idx.textContent = String(cur % N + 1).padStart(2, '0');
      }
      function go(i) { cur = ((i % N) + N) % N; draw(); tk.hold(6); }
      var tk = ticker(sec, 4500, function () { cur = (cur + 1) % N; draw(); });
      sec.querySelectorAll('[data-dmp-vprev]').forEach(function (b) { b.onclick = function () { go(cur - 1); }; });
      sec.querySelectorAll('[data-dmp-vnext]').forEach(function (b) { b.onclick = function () { go(cur + 1); }; });
      stage.addEventListener('mouseenter', function () { tk.hold(3600); });
      stage.addEventListener('mouseleave', function () { tk.hold(0); });
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (x0 == null) return; var d = e.changedTouches[0].clientX - x0; if (Math.abs(d) > 40) go(cur + (d < 0 ? 1 : -1)); x0 = null; }, { passive: true });
      window.addEventListener('resize', draw);
      draw();
    });

    /* ④ 증명된 편안함 — 폰: 막대 누르면 아래 설명 전환, 자동 넘김 */
    root.querySelectorAll('[data-dmp-proof]').forEach(function (sec) {
      if (!once(sec, 'data-dmp-proof')) return;
      var bars = sec.querySelectorAll('.dmp-proof__bar'), ticks = sec.querySelectorAll('.dmp-proof__ticks i'), panes = sec.querySelectorAll('.dmp-proof__pane');
      var panel = sec.querySelector('.dmp-proof__panel'), cur = 0, N = bars.length;
      if (!N) return;
      function set(i) {
        cur = i;
        bars.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        ticks.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        panes.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        if (panel && bars[i]) { panel.style.setProperty('--pbg', bars[i].getAttribute('data-c')); panel.style.setProperty('--pfg', bars[i].classList.contains('is-dark') ? '#FBF8F3' : ''); }
      }
      var tk = ticker(sec, 2800, function () { if (!isPC()) set((cur + 1) % N); });
      bars.forEach(function (b, k) { b.addEventListener('click', function () { set(k); tk.hold(10); }); });
      set(0);
    });

    /* ⑤ 색상 — 자동 전환 · 마우스 올리면 그 색 · 누르면 그 상품으로 */
    root.querySelectorAll('[data-dmp-colors]').forEach(function (sec) {
      if (!once(sec, 'data-dmp-colors')) return;
      var slides = sec.querySelectorAll('.dmp-colors__slide'), dots = sec.querySelectorAll('.dmp-colors__dot');
      var go = sec.querySelector('.dmp-colors__go'), N = slides.length, cur = 0;
      if (!N) return;
      function set(i) {
        cur = i;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        if (go && dots[i]) {
          var h = dots[i].getAttribute('href');
          if (h) go.setAttribute('href', h); else go.removeAttribute('href');   /* 비공개 상품은 링크 없음 — 404 로 보내지 않는다 */
          go.style.pointerEvents = h ? '' : 'none';
          go.querySelector('b').textContent = dots[i].getAttribute('data-name');
          go.setAttribute('data-dm-name', dots[i].getAttribute('data-dm-name'));
        }
      }
      var tk = ticker(sec, 3200, function () { set((cur + 1) % N); });
      /* 10/1: 다른 색을 누르면 바로 넘어가지 않고 확인 창 (클로드 디자인 핸드오프 design_handoff_br001_updates ②)
         PC = 가운데 창(왼쪽 사진) / 폰 = 아래에서 올라오는 시트 · 10/2 사장님 시안으로 단순화(BR-001 · 색별 한 줄 · 이름·가격 · ○○ 보러가기 → · 닫기)
         동그라미·큰 카드·「제품 보기 →」 공통 · 지금 보는 색은 창 없이 선택만 */
      var KO = { 'Sand Beige': '샌드베이지', 'Oyster Grey': '오이스터그레이', 'Core Black': '코어블랙' };
      /* 10/2 사장님 시안: 창을 단순하게 — BR-001 / 색별 한 줄 / 이름·가격 / 「○○ 보러가기 →」 · 10/7 아래 「닫기」 삭제(X·바깥 클릭·ESC 로 닫힘, 클로드 디자인 PC 3차) */
      var LINE = { 'Sand Beige': '편안한 하루를 위한 베이지', 'Oyster Grey': '도시 일상을 위한 그레이', 'Core Black': '더 높은 퍼포먼스를 위한 블랙' };
      var si = parseInt(sec.getAttribute('data-start') || '0', 10);
      function hrefOf(k) { return dots[k] && dots[k].getAttribute('href'); }
      function samePage(k) { var h = hrefOf(k); if (!h) return false; var here = location.pathname.replace(/\/$/, ''), there = h.split('?')[0].replace(/\/$/, ''); return here === there || here.endsWith(there); }
      function imgOf(k) { var im = slides[k] && slides[k].querySelector('.dmp-colors__card img'); return im ? (im.currentSrc || im.src) : ''; }
      function nameOf(k) { return dots[k].getAttribute('data-name'); }
      function koOf(k) { return KO[nameOf(k)] || dots[k].getAttribute('data-ko'); }
      var el = null;
      function close() { if (!el) return; el.classList.remove('is-on'); document.documentElement.style.overflow = ''; tk.hold(0); }
      function fill(k) {
        el.querySelector('.dmp-cs__media img').src = imgOf(k);
        el.querySelector('.dmp-cs__media img').alt = 'BR-001 ' + nameOf(k);
        el.querySelector('.dmp-cs__title').textContent = LINE[nameOf(k)] || (dots[k].getAttribute('data-ko') + ' 컬러');
        el.querySelector('.dmp-cs__name').textContent = nameOf(k);
        el.querySelector('.dmp-cs__price').textContent = (dots[k].getAttribute('data-price') || '').replace(/\.00$/, '');
        var go = el.querySelector('.dmp-cs__go'); go.href = hrefOf(k); go.setAttribute('data-dm-name', dots[k].getAttribute('data-dm-name') || nameOf(k));
        go.querySelector('span').textContent = (dots[k].getAttribute('data-ko') || koOf(k)) + ' 보러가기';
      }
      function sheet(k) {
        if (!hrefOf(k) || samePage(k)) return false;
        if (!el) {
          el = document.createElement('div'); el.className = 'dmp-cs';
          el.innerHTML = '<div class="dmp-cs__box" role="dialog" aria-modal="true" aria-label="다른 컬러 제품 이동 확인"><i class="dmp-cs__grab" aria-hidden="true"></i><button type="button" class="dmp-cs__close" data-x aria-label="닫기">×</button>'
            + '<div class="dmp-cs__media"><img alt=""></div><div class="dmp-cs__body"><div class="dmp-cs__head"><span class="dmp-cs__lbl">BR-001</span><span class="dmp-cs__title"></span></div>'
            + '<div class="dmp-cs__row"><span class="dmp-cs__name"></span><span class="dmp-cs__price"></span></div>'
            + '<div class="dmp-cs__btns"><a class="dmp-cs__go" data-dm="ProductClick" data-dm-at="colors-sheet"><span>제품 보러가기</span><i aria-hidden="true">→</i></a></div></div></div>';
          document.body.appendChild(el);
          el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('[data-x]')) close(); });
          document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
        }
        fill(k); el.classList.add('is-on'); document.documentElement.style.overflow = 'hidden'; tk.hold(3600);
        el.querySelector('.dmp-cs__go').focus({ preventScroll: true });
        return true;
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function (e) { set(k); tk.hold(8); if (sheet(k) || samePage(k)) e.preventDefault(); }); });   /* 지금 보는 색 = 새로고침하지 않고 그 색만 */
      slides.forEach(function (sl, k) { sl.addEventListener('click', function (e) { if (sheet(k) || samePage(k)) e.preventDefault(); }); });
      if (go) go.addEventListener('click', function (e) { if (sheet(cur) || samePage(cur)) e.preventDefault(); });
      dots.forEach(function (d, k) { d.addEventListener('mouseenter', function () { set(k); tk.hold(6); }); });
      set(Math.max(0, parseInt(sec.getAttribute('data-start') || '0', 10)));
    });

    /* ⑥ 사이즈 가이드 슬라이더 — 평소 사이즈 → 딱 맞게 / 여유있게 */
    root.querySelectorAll('[data-dmp-size]').forEach(function (sec) {
      if (!once(sec, 'data-dmp-size')) return;
      var rail = sec.querySelector('.dmp-size__rail'), inp = rail.querySelector('input'), pill = sec.querySelector('.dmp-size__pill');
      var ticks = sec.querySelectorAll('.dmp-size__ticks span'), r1 = sec.querySelector('[data-r1]'), r2 = sec.querySelector('[data-r2]');
      var lo = +inp.min, hi = +inp.max, pct = function (x) { return ((x - lo) / (hi - lo) * 100) + '%'; };
      function upd() {
        var S = +inp.value, a = S % 10 === 0 ? S : S - 5, b = Math.min(hi, S % 10 === 0 ? S + 10 : S + 5);
        rail.style.setProperty('--pos', pct(S)); rail.style.setProperty('--l', pct(a)); rail.style.setProperty('--r', (100 - (b - lo) / (hi - lo) * 100) + '%');
        pill.textContent = S; r1.textContent = a; r2.textContent = b;
        ticks.forEach(function (t) { var v = +t.textContent; t.classList.toggle('is-on', v === a || v === b); });
      }
      inp.addEventListener('input', upd); upd();
    });

    /* ⑦ 지구본 — 가까워지면 불러오고, 보이면 재생, 안 보이면 멈춤 */
    root.querySelectorAll('[data-dmp-map]').forEach(function (box) {
      if (!once(box, 'data-dmp-map')) return;
      var ctl = null, loading = false, sec = box.closest('.dmp-origin');
      function load() {
        if (loading) return; loading = true;
        var s = document.createElement('script'); s.src = box.getAttribute('data-geo'); s.async = true;
        s.onload = function () {
          var m = document.createElement('script'); m.src = box.getAttribute('data-map'); m.async = true;
          m.onload = function () {
            window.dmPdpMap(box.querySelector('canvas'), box.getAttribute('data-atlas')).then(function (c) {
              ctl = c; box.classList.add('is-live');
              if (box.__vis) { ctl.play(); } else ctl.sleep();
            }).catch(function () { /* 실패하면 그림 한 장(대체 이미지)이 그대로 남는다 */ });
          };
          document.head.appendChild(m);
        };
        document.head.appendChild(s);
      }
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) load(); }, { rootMargin: '600px 0px' }).observe(box);
      new IntersectionObserver(function (es) {
        var e = es[0]; box.__vis = e.intersectionRatio >= 0.3;
        if (box.__vis && sec) sec.classList.add('is-in');
        if (!ctl) return;
        if (box.__vis) { ctl.wake(); ctl.play(); }
        else if (!e.isIntersecting) { ctl.reset(); ctl.sleep(); }
      }, { threshold: [0, 0.3] }).observe(box);
      if (reduce && sec) sec.classList.add('is-in');
    });

    /* ⑧ 상단 탭 — 누르면 부드럽게 이동, 지금 보는 곳 표시 */
    root.querySelectorAll('[data-dmp-tabs]').forEach(function (nav) {
      if (!once(nav, 'data-dmp-tabs')) return;
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-target]'));
      function target(a) {
        var sel = a.getAttribute('data-target').split(',');
        for (var i = 0; i < sel.length; i++) { var el = document.querySelector(sel[i]); if (el) return el; }
        return null;
      }
      /* 테마 머리글이 붙어 다니면 그 높이만큼 탭을 내린다 */
      function headerH() {
        var h = document.querySelector('header-component, .header-wrapper, #header-group, .shopify-section-group-header-group');
        if (!h) return 0; var r = h.getBoundingClientRect(); return r.bottom > 0 && getComputedStyle(h).position.match(/sticky|fixed/) ? Math.max(0, r.bottom) : 0;
      }
      function off() { return headerH() + nav.offsetHeight + 8; }
      var lock = 0;
      function mark(k) { links.forEach(function (a, i) { a.classList.toggle('is-on', i === k); }); }
      links.forEach(function (a, k) {
        a.addEventListener('click', function (e) {
          var t = target(a); if (!t) return; e.preventDefault();
          mark(k); lock = Date.now() + 1400;
          var go = function (smooth) { window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off() + 2, behavior: smooth && !reduce ? 'smooth' : 'auto' }); };
          go(true);
          /* 위쪽 사진이 늦게 뜨면 도착점이 밀린다 → 멈춘 뒤 한 번 더 맞춘다 */
          setTimeout(function () { if (Math.abs(t.getBoundingClientRect().top - off()) > 8) go(false); }, 1200);
        });
      });
      function spy() {
        (nav.closest('.dmp-tabs-wrapper') || nav).style.setProperty('--dmp-tabs-top', headerH() + 'px');
        if (Date.now() < lock) return;
        var y = off() + 4, on = 0;
        links.forEach(function (a, i) { var t = target(a); if (t && t.getBoundingClientRect().top <= y) on = i; });
        links.forEach(function (a, i) { a.classList.toggle('is-on', i === on); });
      }
      window.addEventListener('scroll', function () { requestAnimationFrame(spy); }, { passive: true });
      window.addEventListener('resize', spy); spy();
    });
  }

  /* ⑨ 10/1 구매 영역 (핸드오프 ①) — 요약 상자에 이름·수량 −n+·17% · 진짜 수량 버튼을 대신 누른다 (베이지만) */
  function buyArea() {
    var box = document.querySelector('.product-details .dm-sel');
    var qc = document.querySelector('.product-details .product-form-buttons quantity-selector-component');
    if (!box || !qc || box.__dmBuy) return; box.__dmBuy = 1;
    var input = qc.querySelector('input[name="quantity"]'), minus = qc.querySelector('button[name="minus"]'), plus = qc.querySelector('button[name="plus"]');
    var name = box.querySelector('.dm-sel__name'); if (name && name.textContent.indexOf('DARIMATI') !== 0) name.textContent = 'DARIMATI ' + name.textContent.trim();
    var opt = box.querySelector('.dm-sel__option'), row = document.createElement('div'); row.className = 'dm-sel__row';
    var step = document.createElement('div'); step.className = 'dm-sel__step';
    step.innerHTML = '<button type="button" aria-label="' + L('수량 줄이기', 'Decrease quantity') + '">−</button><output aria-live="polite">1</output><button type="button" aria-label="' + L('수량 늘리기', 'Increase quantity') + '">+</button>';
    if (opt) { opt.parentNode.insertBefore(row, opt); row.appendChild(opt); } else box.insertBefore(row, box.querySelector('.dm-sel__total'));
    row.appendChild(step);
    var bMinus = step.children[0], out = step.children[1], bPlus = step.children[2];
    bMinus.addEventListener('click', function () { if (minus) minus.click(); setTimeout(function () { sync(); }, 50); });
    bPlus.addEventListener('click', function () { if (plus) plus.click(); setTimeout(function () { sync(); }, 50); });
    var pct = document.createElement('span'); pct.className = 'dm-sel__pct';
    var val = box.querySelector('.dm-sel__total-value'); val.parentNode.insertBefore(pct, val);
    var lbl = box.querySelector('.dm-sel__total-label');
    var num = function (t) { return parseInt(String(t || '').replace(/[^0-9]/g, ''), 10) || 0; };
    function sync() {
      var q = Math.max(1, parseInt(input && input.value, 10) || 1);
      out.textContent = q; bMinus.disabled = q <= 1;
      if (lbl) lbl.textContent = L('총 상품금액 (' + q + '개)', 'Total (' + q + ')');
      var c = num((box.querySelector('.dm-sel__compare') || {}).textContent), v = num(val.textContent);
      pct.textContent = c > v && v ? Math.round((c - v) / c * 100) + '%' : '';
    }
    ['quantity-selector:update', 'variant:update', 'cart:update'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(function () { sync(); }, 30); }); });
    if (input) input.addEventListener('change', function () { setTimeout(function () { sync(); }, 30); });
    /* 10/1 사장님: 쿠폰을 받으면 「최종 혜택가」 줄 — 쿠폰 받기(⑩)가 window.__dmCpnRate 를 켜면 보인다 */
    var ben = document.createElement('div'); ben.className = 'dm-sel__benefit'; ben.hidden = true;
    ben.innerHTML = '<span class="dm-sel__benefit-l">' + L('최종 혜택가', 'Your price') + '<small>' + L('첫 구매 쿠폰 10% 적용 시', 'With 10% first-order coupon') + '</small></span><span class="dm-sel__benefit-r"><em></em><b></b></span>';
    box.appendChild(ben);
    var fmt = function (n) { return '₩' + n.toLocaleString('ko-KR'); };
    var sync0 = sync;
    sync = function () {
      sync0();
      var rate = window.__dmCpnRate || 0, v = num(val.textContent);
      if (!rate || !v) { ben.hidden = true; return; }
      var off = Math.round(v * rate);
      ben.querySelector('em').textContent = '−' + fmt(off);
      ben.querySelector('b').textContent = fmt(v - off);
      var sm = ben.querySelector('.dm-sel__benefit-l small'); if (sm) sm.textContent = L('첫 구매 쿠폰 10% 적용 시', 'With 10% first-order coupon') + (window.__dmCpnEnd ? ' · ' + window.__dmCpnEnd : '');
      ben.hidden = false;
    };
    document.addEventListener('dm:coupon', function () { setTimeout(sync, 0); });
    new MutationObserver(function () { sync(); }).observe(val, { childList: true, characterData: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buyArea); else buyArea();

  /* ⑩ 10/1 첫 구매 10% 쿠폰 (클로드 디자인 핸드오프 design_handoff_first_order_coupon) — 베이지만 시범
     「쿠폰 받기」= 쇼피파이 할인코드 FIRST10BEIGE 를 손님 장바구니에 미리 걸어둠(/discount/FIRST10BEIGE → 결제창에서 자동 적용)
     로그인 없이 바로 적용(사장님 10/1 선택) · 1인 1회 = 쇼피파이 「고객당 1회」 · 첫 구매 판정 = 관리자 세그먼트(사장님 설정)
     측정: data-dm="CouponClaim" → dm-track 이 맞춤 이벤트 CouponClaim 으로 기록 */
  function coupon() {
    if (EN) return;   /* 10/9 사장님: 영어판은 쿠폰 없음 (첫 구매 쿠폰은 한국판 전용) */
    return;   /* 10/16 사장님: 베이지 10% 쿠폰 페이지에서 내림 (쇼피파이 코드 FIRST10BEIGE 자체는 별도) — 다시 켜려면 이 줄 삭제 */
    var bb = document.querySelector('.product-details .buy-buttons-block');
    if (!bb || document.querySelector('.dm-cpn')) return;
    var CODE = 'FIRST10BEIGE', KEY = 'dm_cpn_first10beige';
    /* 10/1 사장님: 2주 기한 — 쇼피파이 쿠폰 종료일과 반드시 같게 (FIRST10BEIGE endsAt 2026-10-31 23:59:59 KST · 10/10 리타겟팅 광고 위해 10/14→10/31 연장)
       기한이 지나면 쿠폰 칸·혜택가를 아예 안 그린다 (끝난 혜택을 보여주지 않기) */
    var END = new Date('2026-10-31T23:59:59+09:00'), ENDTXT = L('10/31까지', 'Ends Oct 31');
    if (Date.now() > END.getTime()) return;
    var has = function () { try { return /(^|;\s*)discount_code=FIRST10BEIGE(;|$)/i.test(document.cookie) || localStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
    var box = document.createElement('div'); box.className = 'dm-cpn';
    box.innerHTML = '<span class="dm-cpn__lbl">FIRST ORDER BENEFIT</span><div class="dm-cpn__ticket"><i class="dm-cpn__notch is-l" aria-hidden="true"></i><i class="dm-cpn__notch is-r" aria-hidden="true"></i>'
      + '<div class="dm-cpn__txt"><b>10% OFF</b><span class="dm-cpn__sub">' + L('첫 구매 즉시 할인 · 1인 1회 · ', 'First order · One per customer · ') + ENDTXT + '</span></div>'
      + '<button type="button" class="dm-cpn__btn" data-dm="CouponClaim" data-dm-name="FIRST10BEIGE 베이지 첫 구매 10%" aria-label="' + L('첫 구매 10% 쿠폰 받기', 'Get 10% first-order coupon') + '"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M11 3v11M6 9.5l5 5 5-5M5 19h12"/></svg><span>' + L('쿠폰 받기', 'Get coupon') + '</span></button></div>';
    bb.parentNode.insertBefore(box, bb.nextSibling);
    var btn = box.querySelector('.dm-cpn__btn');
    function done() {
      box.classList.add('is-done');
      btn.innerHTML = '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 11.5l4 4 8-9"/></svg><span>' + L('발급 완료', 'Applied') + '</span>';
      btn.setAttribute('aria-label', L('쿠폰 발급 완료', 'Coupon applied')); btn.removeAttribute('data-dm');
      box.querySelector('.dm-cpn__sub').textContent = L('결제 시 자동 적용 · ', 'Applied at checkout · ') + ENDTXT;
      window.__dmCpnEnd = ENDTXT;
      window.__dmCpnRate = 0.1; document.dispatchEvent(new CustomEvent('dm:coupon'));   /* 요약 상자에 최종 혜택가 */
    }
    if (has()) {
      done();
      /* 10/1: 쇼피파이 쿠폰 기록(discount_code 쿠키)은 브라우저를 닫으면 사라진다(만료일 없음).
         페이지 기억(localStorage)만 남은 채 다시 오면 「혜택가는 보이는데 결제창은 정가」가 된다 → 조용히 다시 걸어둔다 */
      if (!/(^|;\s*)discount_code=FIRST10BEIGE(;|$)/i.test(document.cookie)) fetch('/discount/' + CODE + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
    }
    btn.addEventListener('click', function () {
      if (box.classList.contains('is-done') || btn.disabled) return;
      btn.disabled = true;
      fetch('/discount/' + CODE + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
        .then(function () { try { localStorage.setItem(KEY, '1'); } catch (e) {} done(); })
        .catch(function () { btn.disabled = false; })
        .then(function () { btn.disabled = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', coupon); else coupon();

  /* ⑪ 10/1 하단 구매 바(PC) 가격도 쿠폰 적용가로 — 테마가 가격 칸(priceContainer)을 다시 그려도 따라감 */
  function stickyCpn() {
    var box = document.querySelector('.sticky-add-to-cart__price');
    if (!box) return;
    var tag = box.querySelector('.dm-stk-cpn');
    var rate = window.__dmCpnRate || 0, pr = box.querySelector('.price');
    var unit = pr ? parseInt(pr.textContent.replace(/[^0-9]/g, ''), 10) || 0 : 0;
    if (!rate || !unit) { box.classList.remove('is-cpn'); if (tag) tag.remove(); return; }
    if (!tag) { tag = document.createElement('span'); tag.className = 'dm-stk-cpn'; tag.innerHTML = '<small>' + L('쿠폰 적용가', 'With coupon') + '</small><b></b>'; box.insertBefore(tag, box.firstChild); }
    var t = '₩' + Math.round(unit * (1 - rate)).toLocaleString('ko-KR');
    if (tag.querySelector('b').textContent !== t) tag.querySelector('b').textContent = t;
    box.classList.add('is-cpn');
  }
  document.addEventListener('dm:coupon', stickyCpn);
  ['variant:update', 'variant:selected'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(stickyCpn, 60); }); });
  (function watch() { var b = document.querySelector('.sticky-add-to-cart__price'); if (!b) return setTimeout(watch, 500); new MutationObserver(function () { var pr = b.querySelector('.price'); if (pr && !b.__dmBusy) { b.__dmBusy = 1; stickyCpn(); b.__dmBusy = 0; } }).observe(b, { childList: true, subtree: true, characterData: true }); stickyCpn(); })();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* 테마 편집기에서 조각을 다시 그릴 때 */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
